import React from "react";
import Section from "./Section.js";
import delivery from "../assets/images/delivery.svg";
import mailbox from "../assets/images/mailbox.svg";
import photocopy from "../assets/images/photocopy.svg";
import mockup from "../assets/images/mockup_transparent.png";
import video from "../assets/images/PrintMATE.mp4";

import "./Features.css";

export default function Features() {
  return (
    <div>
      <div className="spacer3 banner1">
        <div
          style={{
            zIndex: 50,
            // background: "red",
            opacity: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            textAlign: "center",
            paddingLeft: "20%",
            paddingRight: "20%",
          }}
        >
          <div>
            <h1 style={{ fontSize: "8rem", marginBottom: "-2%" }}>PrintMATE</h1>
            <h2>
              <i>"The future of printing"</i>
            </h2>
            <a id="check" href="#video" style={{ textDecoration: "none" }}>
              Check it out
            </a>
          </div>
          <img src={mockup} alt="mockup" width="36%"></img>
        </div>
        <div
          id="video"
          style={{
            marginLeft: "25%",
            // display: "inline-block",
            // textAlign: "center",
            marginTop: "3%",
            paddingBottom: "3.5%",
            zIndex: 0,
          }}
        >
          <video width="70%" autoPlay loop muted>
            <source src={video} type="video/mp4"></source>
          </video>
        </div>
      </div>
      <div id="features"></div>

      <div
        className="spacer waves1"
        style={{ marginTop: "-25%", zIndex: 100 }}
      ></div>

      <Section
        heading="Get prints delivered to your doorstep"
        paragraph="Convenience at its best. Print like never before. Get your printouts to your doorstep through PrintMATE."
        image={delivery}
        alt="Test"
        width="40%"
        height="40%"
        left={true}
        highlights={["doorstep"]}
      />
      <div
        className="spacer waves4" //curve1
        style={{ marginTop: "-25%", zIndex: 100 }}
      ></div>
      <Section
        heading="Send a print from anywhere to anywhere."
        paragraph="Send printouts to friends, family and others locally for the cheapest possible prices."
        image={mailbox}
        alt="Test"
        width="40%"
        height="40%"
        left={false}
        backgroundColor="#1BE046"
        highlights={["anywhere"]}
      />
      <div
        className="spacer waves5"
        style={{ marginTop: "-23.5%", zIndex: 100 }}
      ></div>
      <Section
        highlights={["Print."]}
        heading="Upload. Set. Print."
        paragraph="Your prices, our service. Set how much you want to spend on each order."
        image={photocopy}
        alt="Test"
        width="40%"
        height="40%"
        left={true}
        backgroundColor="#9CD9A4"
      />

      <div
        className="spacer waves6"
        style={{ zIndex: 100, marginBottom: "-23%" }}
      ></div>
    </div>
  );
}
